<template>
  <!-- <vue-custom-scrollbar class="scroll-area"> -->
  <div class="sidebar-menu">
    <ul>
      <li v-if="this.$route.path.includes('admin')">
        <router-link
          tag="div"
          to="/admin/dashboard"
          active-class="active"
          exact-active-class="active"
          class="waves-effect-sidebar menu-item"
        >
          <b-icon class="menu-item-icon" icon="card-text"></b-icon>
          <span>ادمین داشبورد</span>
        </router-link>
      </li>
      <li v-if="menuList.title" class="text-muted menu-title">
        {{ menuList.title }}
      </li>
      <li v-for="(item, index) in menuList.menuItems" :key="index">
        <div
          :class="[
            'waves-effect-sidebar menu-item',
            item.subMenuShow ? 'subdrop' : ''
          ]"
          v-if="item.submenu.length"
          @click="() => showSubMenuClicked(index)"
        >
          <b-icon class="menu-item-icon" :icon="item.icon"></b-icon>
          <span>{{ item.title }}</span>
          <span class="menu-arrow" v-if="item.submenu.length">
            <b-icon icon="chevron-left"></b-icon>
          </span>
        </div>
        <router-link
          tag="div"
          v-else
          :to="item.path"
          active-class="active"
          exact-active-class="active"
          class="waves-effect-sidebar menu-item"
        >
          <b-icon class="menu-item-icon" :icon="item.icon"></b-icon>
          <span>{{ item.title }}</span>
          <span class="menu-arrow" v-if="item.submenu.length">
            <b-icon icon="chevron-left"></b-icon>
          </span>
        </router-link>
        <ul
          v-if="item.submenu.length"
          :class="[item.subMenuShow ? 'show' : '']"
        >
          <li v-for="(subItem, i) in item.submenu" :key="i">
            <router-link
              :to="subItem.path"
              active-class="active"
              exact-active-class="active"
              class="menu-item"
            >
              {{ subItem.title }}
            </router-link>
          </li>
        </ul>
      </li>
    </ul>
  </div>
  <!-- </vue-custom-scrollbar> -->
</template>

<script>
// import vueCustomScrollbar from "vue-custom-scrollbar";
import { mapActions, mapState } from "vuex";
import { SET_MENU_ITEM } from "@/store/mutation-types";
import { mainMenu, appMenu, dbMenu } from "../../utils/menuListByRouter";
export default {
  name: "SidebarContent",
  components: {
    // vueCustomScrollbar
  },
  computed: {
    ...mapState("setting", ["menuList"])
  },
  mounted() {
    this.ChangeMenuList(this.$route.meta.menu);
  },
  watch: {
    $route: function() {
      this.ChangeMenuList(this.$route.meta.menu);
    }
  },
  methods: {
    ...mapActions("setting", [SET_MENU_ITEM]),
    showSubMenuClicked: function(i) {
      let menu = { ...this.menuList };
      menu.menuItems[i].subMenuShow = !menu.menuItems[i].subMenuShow;
      this[SET_MENU_ITEM](menu);
    },
    ChangeMenuList: function(menu) {
      switch (menu) {
        case "mainMenu":
          this[SET_MENU_ITEM](mainMenu);
          break;
        case "appMenu":
          this[SET_MENU_ITEM](appMenu(this.$route.params.serviceId));
          break;
        case "dbMenu":
          this[SET_MENU_ITEM](dbMenu(this.$route.params.serviceId));
          break;
      }
    }
  }
};
</script>

<style lang="scss">
.sidebar-menu {
  padding-bottom: 30px;
  padding-top: 30px;
  width: 100%;

  @media (max-width: 991px) {
    & {
      padding: 0;
    }
  }
  .waves-effect-sidebar {
    position: relative;
    cursor: pointer;
    display: inline-block;
    overflow: hidden;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-tap-highlight-color: transparent;
    vertical-align: middle;
    z-index: 1;
    will-change: opacity, transform;
    -webkit-transition: all 0.3s ease-out;
    -moz-transition: all 0.3s ease-out;
    -o-transition: all 0.3s ease-out;
    -ms-transition: all 0.3s ease-out;
    transition: all 0.3s ease-out;
  }

  .menu-title {
    padding: 12px 20px !important;
    letter-spacing: 0.035em;
    pointer-events: none;
    cursor: default;
    font-size: 13px;
  }

  & ul,
  & li,
  & .menu-item {
    border: 0;
    font-weight: normal;
    line-height: 1;
    list-style: none;
    margin: 0;
    padding: 0;
    position: relative;
    text-decoration: none;
    text-align: right;
  }

  & .menu-item {
    line-height: 1.3;
  }
  & > ul > li > .menu-item {
    color: #36404a;
    display: block;
    padding: 12px 20px;
    margin: 4px 0;
    border-right: 3px solid #ffffff;
    &.active {
      z-index: 0;
      background: #f4f8fb !important;
      border-right: 3px solid #5fbeaa;
      color: #5fbeaa !important;
    }
    & .menu-item-icon {
      display: inline-block;
      font-size: 16px;
      line-height: 17px;
      margin-right: 3px;
      margin-left: 15px;
      text-align: center;
      vertical-align: middle;
      width: 20px;
    }
  }
  & ul li {
    & .menu-arrow {
      -webkit-transition: -webkit-transform 0.15s;
      -o-transition: -o-transform 0.15s;
      transition: transform 0.15s;
      position: absolute;
      left: 15px;
      display: inline-block;
      text-rendering: auto;
      line-height: 18px;
      -webkit-transform: translate(0, 0);
      -ms-transform: translate(0, 0);
      -o-transform: translate(0, 0);
      transform: translate(0, 0);
      color: #98a6ad;
    }
  }
  & > ul > li > a.active,
  & .subdrop {
    background: #f4f8fb !important;
    border-right: 3px solid #5fbeaa;
    color: #5fbeaa !important;

    & .menu-arrow {
      -ms-transform: rotate(-90deg);
      -webkit-transform: rotate(-90deg);
      -o-transform: rotate(-90deg);
      transform: rotate(-90deg);
    }
  }
  & ul ul {
    display: none;

    &.show {
      display: block;
    }
    & .menu-item {
      color: #75798b;
      display: block;
      padding: 10px 65px 10px 20px;
      font-size: 13px;
      font-weight: 600;

      &.active {
        color: #5fbeaa;
      }
    }
  }
}

#wrapper.enlarged {
  .sidebar-menu ul {
    & > li {
      position: relative;
      white-space: nowrap;

      &:hover {
        & > .menu-item {
          position: relative;
          width: 260px;
          background: #f4f8fb;
          color: #5fbeaa;
          border-color: #5fbeaa;

          & span {
            display: inline;
          }
        }
        a span {
          display: inline;
        }
        & > ul {
          display: block;
          right: 70px;
          position: absolute;
          width: 190px;

          & .menu-item {
            background: #ffffff;
            box-shadow: none;
            padding-right: 15px;
            position: relative;
            width: 186px;
            z-index: 6;
          }
        }
      }

      & > .menu-item {
        padding: 15px 20px;

        & .menu-item-icon {
          margin-left: 40px !important;
          margin-right: 2px;
          font-size: 20px;
        }
        & span {
          display: none;
          padding-left: 10px;
        }
      }
    }
    & ul {
      border: 2px solid #f4f8fb;
      margin-top: -5px;
      padding-top: 5px;
      z-index: 9999;
      background-color: #ffffff;
    }
  }
  & .menu-title,
  & .menu-arrow {
    display: none !important;
  }
}
</style>
